import BaseComponent from "@js/components/base_component.jsx";

class EuiDnsStatusPanel extends BaseComponent {

  render() {
    const wanted = this.props.wanted_dns_records || [];
    const unwanted = this.props.unwanted_dns_records || [];
    const domain = this.props.domain;

    return (
      <Panel heading="dns_status">
        <div className="form-horizontal">
          <FieldContainer labelText={ I18n.t("phrases.dns_status_verified_label") }>
            { this.props.dns_verified
              ? <span><i className="fa fa-check text-muted" /> Yes{ this.props.dns_verified_time_pretty && <span className="text-muted"> ({ this.props.dns_verified_time_pretty })</span> }</span>
              : <span><i className="fa fa-times text-muted" /> No</span>
            }
          </FieldContainer>
          <FieldContainer labelText={ I18n.t("phrases.dns_status_still_correct_label") }>
            { !this.props.dns_verified
              ? <span className="text-muted">&mdash;</span>
              : ( this.props.dns_regression
                  ? <span><i className="fa fa-exclamation-triangle text-muted" /> No{ this.props.dns_regression_time_pretty && <span className="text-muted"> ({ this.props.dns_regression_time_pretty })</span> }</span>
                  : <span><i className="fa fa-check text-muted" /> Yes</span>
                )
            }
          </FieldContainer>
          { this.props.dns_verified && this.props.dns_regression && (
            <div className="form-group">
              <div className="col-sm-offset-4 col-sm-8">
                <span className="text-warning">{ I18n.t("phrases.dns_status_regression_note") }</span>
              </div>
            </div>
          )}
        </div>

        { wanted.length > 0 && (
          <div>
            <h4>{ I18n.t("headings.wanted_dns_records") }</h4>
            <table className="table table-condensed" style={{fontFamily: "monospace"}}>
              <thead>
                <tr>
                  <th style={{width: "40px"}}></th>
                  <th style={{width: "100px"}}>{ t("headings.type") }</th>
                  <th style={{width: "350px"}}>{ t("headings.name") }</th>
                  <th>{ t("headings.value") }</th>
                </tr>
              </thead>
              <tbody>
                { wanted.map((record, i) => (
                  <tr key={ i }>
                    <td>
                      { record.verified
                        ? <span className="text-success"><i className="fa fa-check" /></span>
                        : <span className="text-danger"><i className="fa fa-times" /></span>
                      }
                    </td>
                    <td>{ record.type }</td>
                    <td>
                      { record.name }
                      {" "}
                      <a href="#" className="btn btn-xs btn-default copy-icon-btn" onClick={ (e) => { e.preventDefault(); e.currentTarget.blur(); this._copyToClipboard(record.name); } } title={ I18n.t("labels.copy") }>
                        <i className="fa fa-copy" />
                      </a>
                    </td>
                    <td>
                      <span>{ record.value }</span>
                      {" "}
                      <a href="#" className="btn btn-xs btn-default copy-icon-btn" onClick={ (e) => { e.preventDefault(); e.currentTarget.blur(); this._copyToClipboard(record.value); } } title={ I18n.t("labels.copy") }>
                        <i className="fa fa-copy" />
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="text-right">
              <a href="#" className="btn btn-xs btn-default" onClick={ (e) => { e.preventDefault(); e.currentTarget.blur(); this._copyZoneRecords(wanted); } }>
                <i className="fa fa-copy" /> { I18n.t("buttons.copy_zone_records") }
              </a>
              {" "}
              <a href="#" className="btn btn-xs btn-default" onClick={ (e) => { e.preventDefault(); this._downloadZoneFile(domain, wanted); } }>
                <i className="fa fa-download" /> { I18n.t("buttons.download_zone_file") }
              </a>
            </div>
          </div>
        )}

        { unwanted.length > 0 && (
          <div>
            <hr/>
            <h4>{ I18n.t("headings.unwanted_dns_records") }</h4>
            <p className="text-muted">{ I18n.t("phrases.unwanted_dns_records_subtitle") }</p>
            <table className="table table-condensed" style={{fontFamily: "monospace"}}>
              <thead>
                <tr>
                  <th style={{width: "40px"}}></th>
                  <th style={{width: "100px"}}>{ t("headings.type") }</th>
                  <th style={{width: "350px"}}>{ t("headings.name") }</th>
                  <th>{ t("headings.value") }</th>
                </tr>
              </thead>
              <tbody>
                { unwanted.map((record, i) => (
                  <tr key={ i }>
                    <td>
                      <span className="text-danger"><i className="fa fa-times" /></span>
                    </td>
                    <td>{ record.type }</td>
                    <td>{ record.name }</td>
                    <td>{ record.value }</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Panel>
    );
  }

  _copyToClipboard(text) {
    navigator.clipboard.writeText(text);
  }

  _formatZoneFileRecords(records) {
    return records.map((r) => r.bind).join("\n") + "\n";
  }

  _copyZoneRecords(records) {
    navigator.clipboard.writeText(this._formatZoneFileRecords(records));
  }

  _downloadZoneFile(domain, records) {
    var content = this._formatZoneFileRecords(records);
    var blob = new Blob([content], { type: "text/plain" });
    var url = URL.createObjectURL(blob);
    var a = document.createElement("a");
    a.href = url;
    a.download = domain + ".conf";
    a.click();
    URL.revokeObjectURL(url);
  }

}

export default EuiDnsStatusPanel;
